import React, { useContext } from "react";
///styling
import "../../Styles/MainPage.scss";

//to use browser history
import { useHistory } from "react-router-dom";

//for fade in effect
import FadeIn from "react-fade-in";

//global state
import { StateContext, StateDispatchContext } from "../../AppStateContext";

const ComingSoonFeature = ({ module }) => {
  //consume global state
  const setState = useContext(StateDispatchContext);
  const state = useContext(StateContext);

  //consume browser history
  const history = useHistory();

  const takeUserBack = () => {
    history.push(`/console/${state.currentModule}`);
    setState({
      ...state,
      module: { ...state.module, isComingSoonPageDisplayed: false },
    });

    window.scrollTo(0, 0);
  };

  return (
    <FadeIn transitionDuration={1000}>
      <div className="__ComingSoonFeature">
        <h1
          className={
            state.theme === "dark"
              ? "__comingSoonFeatureHeaderDark"
              : "__comingSoonFeatureHeaderLight"
          }
        >
          This feature is coming soon. Stay tuned!
        </h1>
        <button
          id="comingSoonFeatureButton"
          className={
            state.theme === "dark"
              ? "__comingSoonFeatureButtonDark"
              : "__comingSoonFeatureButtonLight"
          }
          onClick={takeUserBack}
        >{`Got it, take me back to the ${state.currentModule} module.`}</button>
      </div>
    </FadeIn>
  );
};

export default ComingSoonFeature;
